(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/responsive/assets/javascripts/constants.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/responsive/assets/javascripts/constants.trinidad.js'); "use strict";

(function () {

  "use strict";


  var __webpack_require__ = {};





  (function () {

    __webpack_require__.d = function (exports, definition) {
      for (var key in definition) {
        if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }

      }

    };

  })();





  (function () {
    __webpack_require__.o = function (obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    };

  })();



  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": function _default() {
      return __WEBPACK_DEFAULT_EXPORT__;
    }

  });


  var DEVICE_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'];

  var __WEBPACK_DEFAULT_EXPORT__ = DEVICE_SIZES;
  ((window.svs = window.svs || {}).ui = window.svs.ui || {}).responsive = __webpack_exports__.default;
})();
 })(window);